"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultShutdownPlugin = void 0;
const plugin_1 = require("../plugin");
const SHUTDOWN_SIGNALS = ["SIGINT", "SIGUSR1", "SIGUSR2", "SIGTERM", "beforeExit", "exit"];
/**
 * Detect shutdown signals and notify every components of the application
 */
let DefaultShutdownPlugin = class DefaultShutdownPlugin extends plugin_1.BasePlugin {
    constructor() {
        super(...arguments);
        this.isTerminating = false;
    }
    install(ctx, config) {
        if (ctx.platform !== "node")
            throw new Error("This plugin is only usable in a Node environment");
        this.handler = async (signal) => {
            if (this.isTerminating)
                return;
            this.isTerminating = true;
            try {
                await ctx.exitApplication();
                SHUTDOWN_SIGNALS.forEach(sig => process.removeListener(sig, this.handler));
                if (signal.startsWith("SIG"))
                    process.kill(process.pid, signal);
                else
                    process.kill(process.pid);
            }
            catch (e) {
                console.error("Error happened during program shutdown", e);
                process.exit(1);
            }
        };
        SHUTDOWN_SIGNALS.forEach(sig => process.on(sig, this.handler));
    }
    async beforeApplicationExit(hook) {
        await super.beforeApplicationExit(hook);
        SHUTDOWN_SIGNALS.forEach(sig => process.off(sig, this.handler));
    }
};
DefaultShutdownPlugin = __decorate([
    plugin_1.Plugin()
], DefaultShutdownPlugin);
exports.DefaultShutdownPlugin = DefaultShutdownPlugin;
//# sourceMappingURL=plugin.js.map